//Production
// const config = {
//     local: "http://localhost:8000",
//     production: "https://blog-server-llqa.onrender.com"
// }

// Locally(url's are written opposite)
const config = {
    local: "http://localhost:8000",
    production: "https://blog-server-llqa.onrender.com"
    // local: "https://blog-server-llqa.onrender.com",
    // production: "http://localhost:8000"
}

export default config;